// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"127":"58676c46","142":"58676c46","447":"58676c46","451":"58676c46","580":"58676c46","869":"58676c46","884":"58676c46","992":"58676c46"}[chunkId] + ".chunk.css";
};